import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import Loading from '../../components/Loading/Loading';

const oktaUrl = process.env.REACT_APP_OKTA_URL;

// const nonce = Math.floor(Math.random() * 99999999);
// const state = Math.floor(Math.random() * 99999999);
// const authParams = [
//   'client_id=nike.nikedigital.highfive',
//   'redirect_uri=http://localhost:3000/okta-redirect',
//   'response_type=id_token%20token',
//   'scope=profile%20openid%20email',
//   `nonce=${nonce}`,
//   `state=${state}`,
// ].join('&');
// const authUrl = `${oktaUrl}/v1/authorize?${authParams}`;

class ValidateSessionPage extends Component {
  constructor(props) {
    super(props);

    this.validateSessionToken = this.validateSessionToken.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
  }

  componentDidMount() {
    const { accessToken } = window.sessionStorage;
    this.validateSessionToken(accessToken)
      .then(this.getUserInfo)
      .catch((err) => {
        logger.log('Error validating session or getting user info :: ', err);
        this.props.history.push('/login');
      });
  }

  async getUserInfo(accessToken) {
    return window
      .fetch(`${oktaUrl}/v1/userinfo`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(response => response.json())
      .then((responseJson) => {
        // logger.log('User info response: ', responseJson);
        this.props.onLogin(
          {
            accessToken,
            email: responseJson.email,
            name: responseJson.name,
            firstName: responseJson.given_name,
            lastName: responseJson.family_name,
            company: responseJson.company
          },
          () => this.props.history.push(this.props.redirectPath),
        );

        return Promise.resolve();
      });
  }

  async validateSessionToken(accessToken) {
    if (window.sessionStorage.accessToken) {
      // logger.log('**** Found a previously stored access token');
      // logger.log('window.sessionStorage.accessToken:', window.sessionStorage.accessToken);

      return window
        .fetch(`${oktaUrl}/v1/introspect`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          },
          body: qs.stringify({
            client_id: 'nike.nikedigital.highfive',
            token: window.sessionStorage.accessToken,
          }),
        })
        .then((response) => response.json())
        .then((responseJson) => {
          // logger.log('Token info: ', responseJson);
          // If the Okta introspection service deemed that the token is inactive,
          // redirect to the login route.
          if (!responseJson.active) {
            return Promise.reject();
          }

          return Promise.resolve(accessToken);
        });
    }

    this.props.history.push('/login');
    return Promise.reject();
  }

  render() {
    return (
      <div className="ncss-container fixed-fluid">
        <div className="ncss-row pt12-sm">
          <div className="ncss-col-sm-12 mt6-sm pt12-sm pt12-sm">
            <Loading />
            {/* <h5>{authUrl}</h5> */}
          </div>
        </div>
      </div>
    );
  }
}

ValidateSessionPage.propTypes = {
  history: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
  redirectPath: PropTypes.string.isRequired,
};

export default ValidateSessionPage;



// WEBPACK FOOTER //
// ./src/containers/ValidateSessionPage/ValidateSessionPage.js